export const ACHAT = 'Achat';
export const VENTE = 'Vente';

export const LISTE_TYPE_SCHEMA_COMPTABLE = [
  { libelle: 'addSchemaComptable.type.achat', code: ACHAT },
  { libelle: 'addSchemaComptable.type.vente', code: VENTE },
];

export const ACTION_FUSION = 'fusion';
